<template>
  <div class="owner-box">
    <div class="main-container">
      <h2 class="">オーナー情報設定</h2>

      <div class="popup-contents-box">

        <div class="sub-contents-box">
          <div class="customer-info">
            <div class="flex">
              <p class="info-title">オーナー名</p>
              <!-- <p class="info-item"><input type="text" name="name" v-model="owner_info.name" /></p> -->
              <p class="info-item"><textarea v-model="owner_info.name" /></p>
            </div>

            <div class="flex">
              <p class="info-title">通知用メールアドレス</p>
              <p class="info-item"><input type="text" name="address" v-model="owner_info.email"></p>
            </div>

            <div class="flex">
              <p class="info-title">電話番号</p>
              <p class="info-item"><input type="text" v-model="owner_info.tel"></p>
            </div>

            <div class="flex">
              <p class="info-title">チェックイン</p>
              <p class="info-item flex3">
                <select class="" name="" v-model="check_in">
                  <option v-for="(value, index) in 24" :key="index" :value="index">{{index}}</option>
                </select>
                <span>時から</span>
              </p>
            </div>
            <div class="flex">
              <p class="info-title">チェックアウト</p>
              <p class="info-item flex3">
                <select class="" name="" v-model="check_out">
                  <option v-for="(value, index) in 23" :key="index" :value="(index + 1)">{{index + 1}}</option>
                </select>
                <span>時まで</span>
              </p>
            </div>
            <!-- <div class="flex">
              <p class="info-title">チェックイン時間</p>
              <p class="info-item flex3">
                <select class="" name="" v-model="check_in[0]">
                  <option v-for="(value, index) in 24" :key="index" :value="index">{{index}}</option>
                </select>
                <span>：００</span>
              </p>
            </div>

            <div class="flex">
              <p class="info-title">チェックアウト時間</p>
              <p class="info-item flex3">
                <select class="" name="" v-model="check_out[0]">
                  <option v-for="(value, index) in 24" :key="index" :value="index">{{index}}</option>
                </select>
                <span>：００</span>
              </p>
            </div> -->

          </div>
          <p><span class="red">※</span>全て入力してください。</p>
        </div>

      </div>
      <div class="flex2">
        <input type="button" class="new-add" @click="edit" value="決定" />
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: 'Owner',
  // ===========================================================================
  // components
  // ===========================================================================
  components: {
  },
  // ===========================================================================
  // data
  // ===========================================================================
  data () {
    return {
      owner_info: {},
      check_in: 0,
      check_out: 23,
      minute: ['00', '10', '15', '20', '30', '40', '45', '50'],
    };
  },
  // ===========================================================================
  // computed
  // ===========================================================================
  computed: {
  },
  // ===========================================================================
  // created
  // ===========================================================================
  created () {
    if (this.$store.getters['loginInfo/owner_info_defect_flag'] === false) {
      this.data_get();
    }
  },
  // ===========================================================================
  // mounted
  // ===========================================================================
  mounted () {
  },
  // ===========================================================================
  // destroyed
  // ===========================================================================
  destroyed () {
  },
  // ===========================================================================
  // methods
  // ===========================================================================
  methods: {
    data_get () {
      let ld = new this.$loader(this);
      ld._data_set({});
      ld._post_cb_f = this.data_get_cb;
      ld._load_start('owner_info_get.php');
    },
    data_get_cb (res) {
      this.owner_info = res.data.owner_info;
      this.check_in = res.data.owner_info.check_in.split(':')[0];
      this.check_out = res.data.owner_info.check_out.split(':')[0];
    },
    edit () {
      if (this.$lib._emptyChk(this.owner_info.name) === false) {
        this.$alert('alert', 'オーナー名を入力してください。');
        return;
      }
      if (this.$lib._emptyChk(this.owner_info.email) === false) {
        this.$alert('alert', '通知用メールアドレスを入力してください。');
        return;
      }
      if (this.$lib._emptyChk(this.owner_info.tel) === false) {
        this.$alert('alert', '電話番号を入力してください。');
        return;
      }
      // if (this.$lib._emptyChk(this.check_in[0]) === false) {
      //   this.$alert('alert', 'チェックイン時間を入力してください。');
      //   return;
      // }
      // if (this.$lib._emptyChk(this.check_out[0]) === false) {
      //   this.$alert('alert', 'チェックアウト時間を入力してください。');
      //   return;
      // }
      this.owner_info.check_in = `${this.check_in}:00`;
      this.owner_info.check_out = `${this.check_out}:00`;

      let ld = new this.$loader(this);
      ld._data_set({owner_info: this.owner_info});
      ld._post_cb_f = this.edit_cb;
      ld._load_start('owner_info_edit.php');

    },
    edit_cb () {
      this.$alert('info', 'オーナー情報を更新しました。');
      this.$store.commit('loginInfo/set_owner_info_defect_flag', false);
    }

  },
  // ===========================================================================
  // watch
  // ===========================================================================
  watch: {
  },
};
</script>

<style lang="scss">
.owner-box {
  text-align: left;

  .main-container {

    .popup-contents-box {
      margin: 20px 0;
      overflow: auto;
      -webkit-overflow-scrolling: touch;
      height: calc(100% - 120px);
      .guide-p {
        height: 40px;
        overflow: auto;
      }
    }
    .sub-contents-box {
      margin-bottom: 0px;
      margin-right: 0px;
    }
    .new-add {
      display: block;
      text-align: center;
      padding: 8px 8px 8px 8px;
      font-size: 16px;
      text-decoration: none;
      border-radius: 3px;
      width: 150px;
    }

    .customer-info {
      border-bottom: 1px solid #d3d4d8;
    }

    .info-title {
      min-width: 180px;
      padding: 3px 13px 3px 3px;
      background: #fbfbfb;
      text-align: right;
      line-height: 1.8;
      border-top: 1px solid #d3d4d8;
      border-left: 1px solid #d3d4d8;
      color: #24273b;
    }

    .info-item {
      padding: 5px;
      flex: 1;
      border-top: 1px solid #d3d4d8;
      border-left: 1px solid #d3d4d8;
      border-right: 1px solid #d3d4d8;
      background: #fbfbfb;
    }
    .flex2 {
      display: flex;
      justify-content:space-between;
    }
    .flex3 {
      display: flex;
      select {
        margin-right: 10px;
      }
    }
    .red {
      color: #ff6e5a;
    }

  }
  @media (max-width: 767px) {
    .main-container {
    }
  }
}
</style>
